import { FC } from 'react';

import { AnalyticsEvent, useAnalytics } from '@bonusly/analytics';
import { Stack } from '@bonusly/design-system';
import { useBuildRecognizeURL } from '@bonusly/url';

import { Route } from '../../config/router';
import { useKeyboardListControl } from '../../hooks/useKeyboardListControl';
import { SearchUser } from '../../types/user';
import { pathWithId } from '../../utils/api';
import { UserCard } from '../User';
import { useSearchContext } from './context';
import { SearchResult } from './SearchResult';
import { toUserType } from './utils';

export const UsersPanel: FC = () => {
	const { users } = useSearchContext();
	const recognizeURL = useBuildRecognizeURL();

	const { isSelected, register } = useKeyboardListControl<SearchUser, HTMLAnchorElement>({
		emitClickOnSelect: true,
		focusSelected: true,
		onSelectOption: (user) => window.location.assign(recognizeURL(pathWithId(Route.UserProfile, user.objectID))),
		options: users,
		selectOnTab: false,
	});

	const { track } = useAnalytics();

	return (
		<Stack as="ul" listStyleType="none">
			{users?.map((user) => {
				const { onClick, ...props } = register(user);

				return (
					<SearchResult
						aria-label={user.display_name}
						isSelected={isSelected(user)}
						key={user.objectID}
						onClick={() => {
							track(AnalyticsEvent.TopNavbar.UserClick);
							onClick();
						}}
						{...props}
					>
						<UserCard user={toUserType(user)} />
					</SearchResult>
				);
			})}
		</Stack>
	);
};
